import { useTranslation } from 'next-i18next';
import { useCartContext, useFeatureFlagsContext, useLocaleContext, useUserContext } from '../../../context';
import { useStar2 } from '../../../hooks/useStar2';
import { Lock } from '../../../icons';
import { CartStorageKeys, createAnchorTagHref, removeItem, setItem, showProgressBar } from '../../../utils';
import { Button, ButtonContainer } from './CheckoutButton.styles';

type CheckoutButtonProps = {
  currency: string;
  total: string;
  isDisabled?: boolean;
  noMaxWidth?: boolean;
};

export function CheckoutButton({ currency, total, isDisabled, noMaxWidth = false }: CheckoutButtonProps) {
  const { t } = useTranslation(['lib-global-common']);

  const { checkoutSecurely, setCheckoutSecurely } = useCartContext();
  const { isUserLoggedIn } = useUserContext();
  const { locale } = useLocaleContext();
  const { isAdyenCheckoutEnabled } = useFeatureFlagsContext();

  const { isStar2 } = useStar2();

  const handleCheckoutSecurely = () => {
    if (!isUserLoggedIn) {
      setCheckoutSecurely(!checkoutSecurely);
    }
  };

  const handleLoggedInCheckoutSecurely = () => {
    showProgressBar();

    setItem(CartStorageKeys.CHECKOUT_FLOW, true);
    removeItem('GUEST_CHECKOUT_EMAIL', 'sessionStorage');
    removeItem('BASKET_MERGED', 'sessionStorage');
  };

  return (
    <ButtonContainer $isDisabled={isDisabled} $noMaxWidth={noMaxWidth}>
      <Button
        $noMaxWidth={noMaxWidth}
        data-testid="miniCartCheckoutButton"
        {...(!isUserLoggedIn
          ? {
              as: 'button',
              type: 'button',
              onClick: handleCheckoutSecurely,
            }
          : {
              as: 'a',
              href: createAnchorTagHref({
                locale,
                path: isStar2 && !isAdyenCheckoutEnabled ? '/checkout' : '/checkout/delivery',
              }),
              onClick: handleLoggedInCheckoutSecurely,
            })}
        $isDisabled={isDisabled}
      >
        <Lock />
        <span>
          {t('cart.checkout.cta')}&nbsp;{currency}
          {total}
        </span>
      </Button>
    </ButtonContainer>
  );
}
